export default {
    featureBeta: process.env.VUE_APP_FEATURE_BETA === 'true',
    featureMaintenance: process.env.VUE_APP_FEATURE_MAINTENANCE === 'true',
    authorizedLanguage: ['fr-FR', 'en'],
}
